module.exports = __webpack_public_path__ + "linkedin.svg?5b238434e2862c877f08572b96c0ef7b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/linkedin.svg
// module id = 412
// module chunks = 0